import styled, { keyframes } from "styled-components";
import pinkHeader from "../assets/images/pink-rect-header.png";

export const PageWrapper = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 3rem;
  box-sizing: border-box;

  /* @media (max-width: 48rem) {
    display: flex;
    flex-direction: column;
  } */
`;

//NavBar.js
export const NavWrapper = styled.nav`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 3rem;
  gap: 1rem;
`;

export const NavLinksWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-around;

  background-image: url(${pinkHeader});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;

  min-height: 6rem;
  padding: 0.75rem 2rem;
  box-sizing: border-box;
  max-width: 70vw;

  @media (max-width: 48rem) {
    display: none;
  }
`;

export const LogoWrapper = styled.div`
  width: 9.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  letter-spacing: 0.05em;

  img {
    width: 100%;
    height: auto;
  }

  @media (max-width: 48rem) {
    width: 3.75rem;
    font-size: 0.8rem;
  }
`;

export const MobileMenuWrapper = styled.div`
  display: none;

  @media (max-width: 48rem) {
    position: relative;
    display: flex;
    flex-direction: column;
  }
`;

export const MobileNavRect = styled.div`
  width: 6rem;
  height: 2.6rem;

  background-image: url(${(props) => props.$bgImage});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  filter: drop-shadow(0 0.25rem 0.4rem rgba(0, 0, 0, 0.5));

  transform: ${(props) => (props.$isOpen ? props.$translate : "none")};
  transition: transform 1s cubic-bezier(0.33, 1, 0.68, 1);

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    color: ${(props) => (props.$isOpen ? "white" : "transparent")};
    text-decoration: none;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    margin: 0;
    pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
    transition: color 1s cubic-bezier(0.33, 1, 0.68, 1);
  }
`;

//Footer.js
const tickerAnimation = keyframes`
0% {transform: translateX(0);}
100% {transform: translateX(-50%);}`;

export const TickerInner = styled.div`
  display: inline-flex;
  animation: ${tickerAnimation} 50s linear infinite;
`;

//Hero.js
export const ContentWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 2rem 4rem 4rem 0rem;
  align-items: flex-end;
  max-width: 60%;
  margin-left: auto;

  @media (max-width: 48rem) {
    max-width: 100%;
    padding: 4rem 2rem 3rem;
    margin-left: 0;
    align-items: flex-start;
    gap: 1rem;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 5rem;
  padding-top: 2rem;

  width: 100%;
  max-width: 40rem;
  align-items: flex-start;

  @media (max-width: 48rem) {
    padding-left: 0;
    gap: 1rem;
    max-width: 85%;

    align-self: flex-end;
    align-items: flex-end;
    margin-bottom: -1rem;
  }
`;
